// extracted by mini-css-extract-plugin
export default {"ErrorContainer":"_ErrorContainer--DicMy","Header":"_Header--soWag","Contact":"_Contact--ZP2bP","BoxMenu":"_BoxMenu--dCRRo"};